import {gql} from 'apollo-angular';
import {StatusFragment} from "../../fragments/Status";

export const SEND_QUIZ_ANSWER = gql`
  query SendQuizAnswer($gameId: Int!, $questionId: Int!, $answerId: Int!) {
    sendQuizAnswer(gameID: $gameId, questionID: $questionId, answerID: $answerId) {
        status {
          ...statusFields
        }
        correctAnswerId
    }
  }
  ${StatusFragment}
`;

